import { createSelector } from 'reselect';
import * as root from '../';
import { Warehouse } from './warehouse.model';

export const getForAssetModal = createSelector(root.getAssetModalSelectedWarehouseId, root.getWarehouseEntities, (id, warehouseMap) => warehouseMap[id]);

export const getForAssetModalSelectedDivision = createSelector(root.getAssetModalSelectedDivisionId, root.getDivisionWarehousesIds, root.getWarehouseEntities, (selectedDivisionId, divWarehouseIds, warehouseEnts) => {
    return divWarehouseIds[selectedDivisionId] ? divWarehouseIds[selectedDivisionId].map(id => new Warehouse(warehouseEnts[id])) : [];
});
